import {Component, OnInit, ViewChild, Output, EventEmitter, Input, ViewEncapsulation, AfterViewInit, ElementRef} from '@angular/core';
import moment from 'moment';
import 'moment-timezone';
import {SharedConstant} from '../../constants/sharedConstants';
import {UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';
import {SharedService} from '../../shared.service';

@Component({
  selector: 'ems-date-range-filter',
  templateUrl: './date-range-filter.component.html',
  styleUrls: ['./date-range-filter.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DateRangeFilterComponent implements OnInit, AfterViewInit {
  dates: any;
  ranges: any[];
  dateValue: Date[];
  getCommConst = SharedConstant;
  isClicked: any;

  @ViewChild('myCalendar', { static: true }) datePicker;
  @Output() submittedDate = new EventEmitter<any>();
  @Input() disableForm = false;
  @Input() selectFuturedates = false;
  @Input() limitCustomRangeTo6Months: boolean;
  @Input() limitCustomRangeTo1Month: boolean;
  @Input() dateFilterLabel = 'Date range filter';
  originalHideOverlay! : any;
  blockNextHide = false;
  datePickerInputId = 'date-range-filter-input';

  constructor(public fb: UntypedFormBuilder, public sharedService: SharedService, private hostElement: ElementRef) {
  }


  dateRangeForm: UntypedFormGroup = this.fb.group({
    dateSelected: ['', {standalone: true}]
  });
  maxDateValue: Date;
  public minDateValue: Date;

  ngOnInit() {
    const hostId = this.hostElement?.nativeElement?.getAttribute('id');
    this.datePickerInputId = hostId ? `${hostId}_input` : this.datePickerInputId;

    this.ranges = this.limitCustomRangeTo6Months || this.limitCustomRangeTo1Month ? ['Today', 'Yesterday', 'Current Month', 'Custom Range'] : ['Today', 'Yesterday', 'Current Month', 'Current Year', 'Custom Range'];
    if (!this.selectFuturedates) {
      this.maxDateValue = new Date(moment().tz('America/New_York').format(this.getCommConst.date_format.mm_dd_yy));
      moment(this.maxDateValue, 'MM/DD/YYYY').format('MM/DD/YYYY');
    }

    if (this.limitCustomRangeTo6Months || this.limitCustomRangeTo1Month) {
      const dateVal = this.limitCustomRangeTo6Months ? this.getCommConst.oneSeventyNineDays : this.getCommConst.twentyNineDays;
      const getCurrentDate = new Date(moment().tz('America/New_York').format(this.getCommConst.date_format.mm_dd_yy));
      this.minDateValue = moment(getCurrentDate).subtract(dateVal, 'days').toDate();
      moment(this.minDateValue, 'MM/DD/YYYY').format('MM/DD/YYYY');
    }

    if (this.sharedService.requestStatus === this.getCommConst.requireIndexing || this.sharedService.requestStatus === this.getCommConst.clientCentralLinks || this.sharedService.requestStatus === this.getCommConst.clientCentralDelinks) {
      const fromDate = moment(this.sharedService.requestStatusFilterObj.fromDate).toDate();
      const toDate = moment(this.sharedService.requestStatusFilterObj.toDate).toDate();
      const date = [fromDate, toDate];
      // const date = [];
      this.dateValue = date;
    }

    this.sharedService.updatedDate.subscribe((data) => {
      if (data && data.name === 'Require Indexing') {
        const fromDate: Date = moment(data.fromDate, this.getCommConst.date_format.mm_dd_yy).toDate();
        const toDate = moment(data.toDate, this.getCommConst.date_format.mm_dd_yy).toDate();
        const date = [fromDate, toDate];
      // const date = [];
        this.dateValue = date;
      }
    });
  }

  performRangeSelection(range) {
    const today = new Date(moment().tz('America/New_York').format(this.getCommConst.date_format.mm_dd_yy));
    switch (range) {
      case 'Yesterday':
        const firstDate = moment(today).subtract(1, 'days').toDate();
        this.dateValue = [firstDate, firstDate];
        break;
      case 'Current Month':
        this.dateValue = [moment().startOf('month').toDate(), moment().endOf('day').toDate()];
        this.dateValue[1] = moment(today).toDate();
        break;
      case 'Current Year':
        this.dateValue = [moment().startOf('year').toDate(), moment().endOf('day').toDate()];
        this.dateValue[1] = moment(today).toDate();
        break;
      case 'Custom Range':
        this.dateValue = [today];
        break;
      default:
        this.dateValue = [today, today];
        break;
    }
    this.submittedDate.emit(this.dateValue);
  }

  applyDate() {
    // Code changes: selected date other than a date range (single date)
    // if (this.dateValue && this.dateValue[1] === null) {
    //   this.dateRangeForm.get('dateSelected').setValue('');
    // }
    this.dateValue = this.dateValue && this.dateValue[1] === null ? [this.dateValue[0], this.dateValue[0]] : this.dateValue;
    this.datePicker.overlayVisible = false;
    this.submittedDate.emit(this.dateRangeForm.get('dateSelected').value);
  }

  clearSelection() {
    this.isClicked = '';
    this.datePicker.overlayVisible = false;
    this.dateRangeForm.reset();
    this.submittedDate.emit(this.dateRangeForm.get('dateSelected').value);
  }

  openCalendar() {
    setTimeout(() => {
      const elem = document.querySelector('.ui-datepicker');
      if (elem instanceof HTMLElement) {
        const second = '40px';
        const localVar = parseInt(elem.style.left, 10) - parseInt(second, 10) + 'px';
        elem.style.left = localVar;
        elem.style.zIndex = '33333333333333333333';
      }
    }, 1);
    this.datePicker.overlayVisible = true;
  }

  applyToDate() {
    if (this.dateValue && this.dateValue[1] === null) {
      this.dateValue[1] = this.dateValue[0];
    }
  }

  ngAfterViewInit(): void {
    if (!this.datePicker || typeof this.datePicker.hideOverlay !== 'function') {
      return;
    }
    // Save the original method and bind its 'this'
    this.originalHideOverlay = this.datePicker.hideOverlay.bind(this.datePicker);

    // Overide hideOverlay on the fly
    this.datePicker.hideOverlay = () => {
      if (this.blockNextHide) {
        // if flag is true, consume the call and reset the flag
        this.blockNextHide = false;
        return;
      }
      // Otheriwise, behave as usual
      this.originalHideOverlay();
    };
  }

  handleRangeSelection() {
    // set the flag so that the next hideOverlay() will be skipped instead of closing the panel.
    this.blockNextHide = true;
  }
}
